<template>
  <div>
    <div v-if="loading">
      <div class="card-panel" v-loading="loading" style="height:110px">

      </div>
    </div>

    <template v-else-if="ledger">
      <cardBalanceView 
        v-if="ledger.vender_type !== 'ifx'" 
        :ledger="ledger"
        v-on:onClick="viewAccount()"
        >
      </cardBalanceView>

      <cardBalanceViewIFX 
        v-if="ledger.vender_type === 'ifx'" 
        :ledger="ledger"
        v-on:onClick="viewAccount()"
        >
      </cardBalanceViewIFX>
      </template>
    </div>

</template>

<script>
import cardBalanceView from "./card-balance-view.vue";
import cardBalanceViewIFX from "./card-balance-view-ifx.vue";
import {
  getProjectBalanceByLedger,
  getCustomerBalanceByLedger,
} from "@/api/bank-account";
export default {
  props:{
    projectUID: String,
    customerUID: String,
    ledgerID: String,
    apiMode:String,
    // Balance already loaded by the parent's batch request; fetch this ledger alone only without it.
    balance: Object
  },
  watch:{
    balance(val){
      if(val){
        this.ledger = val
      }else{
        this.getLedgerBalance()
      }
    }
  },
  components:{
    cardBalanceView,
    cardBalanceViewIFX
  },
  data(){
    return{
        loading: false,
        ledger : null
    }
  },
  methods:{
    getLedgerBalance(){
      this.loading = true
      if(this.apiMode === 'project'){
        getProjectBalanceByLedger(this.projectUID, this.ledgerID).then(({result, data})=>{
          if(result){
              this.ledger = data
          }
        }).finally(()=>{
          this.loading = false
        })
      }
      if(this.apiMode === 'customer'){
        getCustomerBalanceByLedger(this.customerUID, this.ledgerID).then(({result, data})=>{
          if(result){
              this.ledger = data
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    viewAccount(){
      this.$router.push(`/bank-account/view/${this.apiMode}/${this.ledger.bankholderID}`)
    },

  },
  created(){
    if(this.balance){
      this.ledger = this.balance
      return
    }
    this.getLedgerBalance()
  }
};
</script>
